/** @jsx jsx */
import { Flex, Paragraph } from "@eworkit/iris";
import { format, isSameDay } from "date-fns";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { TimeReportDayAggregate } from "@/data/time-reports";
import { middleOfDay, useDateFnsLocale } from "@/utils/dates";

import { getTimeReportCalendarCellBackground } from "./grid/TimeReportCalendarCellBackground";
import { TimeReportCalendarRow } from "./grid/TimeReportCalendarRow";
import { TimeReportCalendarRowHeader } from "./grid/TimeReportCalendarRowHeader";
import { TimeReportCalendarRowHeaderCell } from "./grid/TimeReportCalendarRowHeaderCell";

interface TimeReportCalendarHeaderRowProps {
  days: TimeReportDayAggregate[];
}

export const TimeReportCalendarHeaderRow: FC<TimeReportCalendarHeaderRowProps> = ({ days }) => {
  const { t } = useTranslation("session");
  const locale = useDateFnsLocale();

  const today = middleOfDay(new Date());

  return (
    <TimeReportCalendarRow>
      <TimeReportCalendarRowHeader sx={{ py: [10, 10, 10, 10] }}>
        <Paragraph>{t("TIME_REPORTS.CALENDAR.PROJECT_PAYCODE")}</Paragraph>
      </TimeReportCalendarRowHeader>

      {days.map(day => {
        return (
          <TimeReportCalendarRowHeaderCell
            key={day.date.toISOString()}
            background={getTimeReportCalendarCellBackground(day)}>
            <Flex>
              <Paragraph bold={isSameDay(today, day.date)} ellipsis sx={{ textTransform: "capitalize" }}>
                {format(day.date, "EEE dd", { locale })}
              </Paragraph>
            </Flex>
          </TimeReportCalendarRowHeaderCell>
        );
      })}
    </TimeReportCalendarRow>
  );
};
